module.exports = "https://static.wmbcdn.com/uniweb/images/c83f7ba160af73a9eed7f1afaaa266a4.svg";